import { getPositionFromIndex } from "../AutoSuggestion";
let searchState = {
    query: '',
    matches: [],
    currentIndex: -1,
    markers: [],
    activeMarkerId: null
};

export function setupF3Search(ace) {
    const editorElement = ace.current.editor.container; // DOM element

    const width = editorElement.clientWidth;   // width in pixels
    const height = editorElement.clientHeight; // height in pixels

    if (!ace?.current) return;
    const editor = ace.current.editor;
    const handleKeyDown = (e) => {
        if (e.key === 'F3' || e.keyCode === 114) {
            e.preventDefault();
            e.stopPropagation();
            let editorbox = document.getElementById("aceEditorWorkingSpace");

            console.log("the ace editor width and heigh is :Width:", editorbox.offsetWidth, "Height:", editorbox.offsetHeight);
            const selectedText = editor.getSelectedText().trim();
            let queryToSearch = '';
            if (selectedText) {
                // User selected new text - use it as query
                queryToSearch = selectedText;
            } else if (searchState.query) {
                // No selection - continue previous search
                queryToSearch = searchState.query;
            } else {
                console.log('No text selected and no previous search');
                return;
            }
            const currentContent = editor.session.getValue();
            const freshMatches = findAllMatches(currentContent, queryToSearch);
            const isNewQuery = queryToSearch !== searchState.query;
            if (isNewQuery) {
                clearSearchMarkers(editor);
                searchState.query = queryToSearch;
                searchState.currentIndex = -1;
                searchState.markers = [];
                searchState.activeMarkerId = null;
            } else {
                clearSearchMarkers(editor);
                searchState.markers = [];
                searchState.activeMarkerId = null;
            }
            searchState.matches = freshMatches;
            if (searchState.matches.length === 0) {
                console.log('No matches found');
                searchState.currentIndex = -1;
                return;
            }
            if (searchState.currentIndex >= searchState.matches.length) {
                searchState.currentIndex = searchState.matches.length - 1;
            }
            searchState.currentIndex = (searchState.currentIndex + 1) % searchState.matches.length;
            highlightAllMatches(editor, searchState.matches);
            navigateToMatch(
                editor,
                searchState.matches[searchState.currentIndex],
                searchState.currentIndex,
                searchState.matches.length
            );
        }
        if (e.key === 'Escape') {
            clearSearchMarkers(editor);
            searchState = {
                query: '',
                matches: [],
                currentIndex: -1,
                markers: [],
                activeMarkerId: null
            };
        }
    };
    if (editor.container._f3SearchListener) {
        editor.container.removeEventListener('keydown', editor.container._f3SearchListener);
        document.removeEventListener('keydown', editor.container._f3SearchListener);
    }
    editor.container.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keydown', handleKeyDown);
    editor.container._f3SearchListener = handleKeyDown;
}
function findAllMatches(content, query) {
    const matches = [];
    if (!query || query.length === 0) return matches;
    let searchIndex = 0;
    while (searchIndex < content.length) {
        const foundIndex = content.indexOf(query, searchIndex);
        if (foundIndex === -1) break;
        const charBefore = foundIndex > 0 ? content[foundIndex - 1] : ' ';
        const charAfter = foundIndex + query.length < content.length
            ? content[foundIndex + query.length]
            : ' ';
        const isWordBoundaryBefore = /\W/.test(charBefore);
        const isWordBoundaryAfter = /\W/.test(charAfter);
        if (isWordBoundaryBefore && isWordBoundaryAfter) {
            const position = getPositionFromIndex(content, foundIndex, query.length);
            matches.push({
                startIndex: foundIndex,
                endIndex: foundIndex + query.length,
                startRow: position.startRow,
                startCol: position.startCol,
                endRow: position.endRow,
                endCol: position.endCol,
                text: content.slice(foundIndex, foundIndex + query.length)
            });
        }
        searchIndex = foundIndex + 1;
    }
    return matches;
}
function highlightAllMatches(editor, matches) {
    const session = editor.session;
    const Range = window.ace.require('ace/range').Range;
    searchState.markers.forEach(id => session.removeMarker(id));
    searchState.markers = [];
    matches.forEach((match) => {
        const range = new Range(
            match.startRow,
            match.startCol,
            match.endRow,
            match.endCol
        );
        const markerId = session.addMarker(range, 'ace-search-highlight', 'text');
        searchState.markers.push(markerId);
        match.markerId = markerId;
    });
}
function navigateToMatch(editor, match, currentIndex, totalMatches) {
    const session = editor.session;
    const Range = window.ace.require('ace/range').Range;
    if (searchState.activeMarkerId) {
        session.removeMarker(searchState.activeMarkerId);
    }
    const activeRange = new Range(
        match.startRow,
        match.startCol,
        match.endRow,
        match.endCol
    );
    searchState.activeMarkerId = session.addMarker(
        activeRange,
        'ace-search-active',
        'text'
    );
    editor.selection.setRange(activeRange);
    editor.scrollToLine(match.startRow, true, true);
    editor.gotoLine(match.startRow + 1, match.startCol, true);
}
function clearSearchMarkers(editor) {
    const session = editor.session;
    searchState.markers.forEach(id => session.removeMarker(id));
    searchState.markers = [];
    if (searchState.activeMarkerId) {
        session.removeMarker(searchState.activeMarkerId);
        searchState.activeMarkerId = null;
    }
}
export function cleanupF3Search(ace) {
    if (!ace?.current) return;
    const editor = ace.current.editor;
    if (editor.container._f3SearchListener) {
        editor.container.removeEventListener('keydown', editor.container._f3SearchListener);
        document.removeEventListener('keydown', editor.container._f3SearchListener);
        delete editor.container._f3SearchListener;
    }
    clearSearchMarkers(editor);
    searchState = {
        query: '',
        matches: [],
        currentIndex: -1,
        markers: [],
        activeMarkerId: null
    };
}




